import React, { useMemo } from 'react';
import { css } from '@emotion/react';
import { Link } from '@tanstack/react-router';
import { theme } from '@frontend/theme';
import { Accordion, Text } from '@frontend/design-system';
import { UserRole } from '../../utils/constants';
import { checkRbacAccess } from '../../utils/helpers';
import { DocumentationLink } from '../../utils/typings';

interface QuickLinksAccordionProps {
  quickLinks?: DocumentationLink[];
  userRole?: keyof typeof UserRole;
}

const QuickLinksAccordion: React.FC<QuickLinksAccordionProps> = ({ quickLinks = [], userRole }) => {
  const filteredLinks = useMemo(() => {
    if (!quickLinks.length) return [];

    return quickLinks.filter((link) =>
      checkRbacAccess({ accessibleByRoles: link.accessibleByRoles, owner: link.owner }, userRole)
    );
  }, [quickLinks, userRole]);

  return (
    <Accordion variant='main' showBoxShadow>
      <Accordion.Item value='quick-links'>
        <Accordion.Header>
          <Text weight='bold'>Quick Links</Text>
        </Accordion.Header>
        <Accordion.Body>
          {filteredLinks.length ? (
            <ul css={listStyle}>
              {filteredLinks.map((link) => (
                <li key={link.url}>
                  <Link to={link.url} target='_blank' rel='noopener noreferrer' css={linkStyle}>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <Text>No Quick Links available for your role.</Text>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default QuickLinksAccordion;

const listStyle = css`
  padding-left: ${theme.spacing(2)};
`;

const linkStyle = css`
  display: block;
  margin-bottom: ${theme.spacing(2)};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
